import React from "react";

/**
 * LastUploadSummary — compact card shown above the drop-zone when history
 * exists but no preview is active. Extracted so the parent renders a single
 * declarative line.
 */
export default function LastUploadSummary({ log }) {
  if (!log) return null;
  const c = log.counters || log;
  return (
    <div className="mb-4 border-l-4 border-primary bg-secondary/40 px-4 py-3 text-xs" data-testid="last-upload-summary">
      <div className="overline mb-1">Upload Terakhir</div>
      <div className="font-mono">
        <span className="font-bold text-foreground">{log.filename || log.source || "-"}</span>
        <span className="mx-2 text-muted-foreground">·</span>
        <span className="text-muted-foreground">{new Date(log.finished_at || log.at).toLocaleString("id-ID")}</span>
        <span className="mx-2 text-muted-foreground">·</span>
        <span className="text-muted-foreground">oleh {log.triggered_by || log.by || "-"}</span>
      </div>
      <div className="font-mono mt-1">
        <span className="text-emerald-700 font-bold">{c.updated || 0} update</span>
        {" · "}
        <span className="text-red-700">{c.mismatch || 0} mismatch</span>
        {" · "}
        <span className="text-blue-700">{c.already_verified || 0} verified</span>
        {" · "}
        <span className="text-amber-700">{c.not_found || 0} not-found</span>
        {" · "}
        <span className="text-muted-foreground">{c.skipped || 0} skip</span>
      </div>
    </div>
  );
}
